<div class="modal-header">
  <h3 class="modal-title">Archivos</h3>
  <button type="button" class="close text-primary" aria-label="Close"
    (click)="dismissWithConfirm()">
    <i class="fas fa-times-circle"></i>
  </button>
</div>
<div class="modal-body">
  <form #form1="ngForm" (ngSubmit)="submitForm(form1)">
    <app-attachment-view
      #attachmentView
      [enableCategory]="enableCategory"
      (sendingFiles)="retrieveFiles($event)"
      >
    </app-attachment-view>
    @if (loading && uploadLabel) {
      <div class="form-group mt-2">
        <div class="small text-muted mb-1">Subiendo {{ uploadLabel }} ({{ uploadProgress }}%)</div>
        <div class="progress" style="height: 8px;">
          <div class="progress-bar" role="progressbar"
            [style.width.%]="uploadProgress"
            [attr.aria-valuenow]="uploadProgress"
            aria-valuemin="0" aria-valuemax="100"></div>
        </div>
      </div>
    }
    @if (successMessage) {
      <div class="form-group">
        <div class="row">
          <div class="col-md-12">
            <ngb-alert class="mt-3" type="success" (close)="successMessage = ''">{{ successMessage }}</ngb-alert>
          </div>
        </div>
      </div>
    }
    @if (errorMessage) {
      <div class="form-group">
        <div class="row">
          <div class="col-md-12">
            <ngb-alert  class="mt-3" type="danger" (close)="errorMessage = ''">{{ errorMessage }}</ngb-alert>
          </div>
        </div>
      </div>
    }
    <div class="form-group">
      <div class="row">
        <div class="col-md-12 text-right">
          <button type="button" class="btn btn-outline-dark rounded-pill font-weight-bold" style="width: 120px;"
            (click)="dismissWithConfirm()" [disabled]="loading">
            Cerrar
          </button>
          <button type="submit"
            class="btn btn-outline-primary  rounded-pill text-dark  font-weight-bold mr-2"
            style="width: 120px;"
            [disabled]="loading"
            >
            @if (loading) {
              <div>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                {{ uploadProgress }}%
              </div>
            }
            @if (!loading) {
              <span>
                Guardar
              </span>
            }
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
